import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { Imagesdata } from "../../assets/images/imageData";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import services from "../../API/services";
import { useForm, Controller } from "react-hook-form";
import validations from "../../components/checkInModal/Validation";
import { InputField } from "../../components/InputField/InputField";
import { ErrorMessage } from "@hookform/error-message";
import { toast } from "react-toastify";
import { showPrice } from 'utils/utils';
import moment from 'moment';

const PAYMENT_MODES = {
    PAYLATER: 6,
    CASH: 2,
    CARD: 3,
    FOC: 4,
    UPI: 5,
    PAYLATER: 6,
    PREPAID: 7,
};

const PaymentModal = (props) => {
    const {
        paymentModal,
        setPaymentModal,
        orders,
        refreshKot,
        setSingleOrders
    } = props

    const { register, handleSubmit, setValue, reset, watch, formState: { errors }, } = useForm();

    const { AlertIcon } = Imagesdata || {};
    const { userDetail } = useSelector(authenticationSeletor);
    const [currentOrder, setCurrentOrder] = useState(orders);
    const [buttonDisable, setButtonDisable] = useState(false);

    useEffect(() => { setCurrentOrder(orders); }, [orders]);

    let myOrder = [];

    if (orders?.orderItems) {
        try {
            myOrder = JSON.parse(orders.orderItems);
        } catch (error) {
            console.error('Invalid JSON:');
            myOrder = [];
        }
    }

    let bookingDetails = {}

    const handleFoodOrderDiscount = async (e) => {
        if (foodDiscount > 100) {
            toast.error("Can not apply discount upto 100%", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
            return
        }
        try {
            let payload = {
                discountPercentage: foodDiscount,
                dueAmount: payAmount,
                afterDiscount: Math.round(afterDiscountAmount)
            }
            const res = await services.property.kotOrderDiscountService(payload, orders?.id)
            if (res.status === 200 && res.data.status === true) {
                toast.success(`${foodDiscount}% Discount applied`, { autoClose: 1000, pauseOnHover: true, position: "top-right" });
                setPaymentInput(false)
                refreshKot();
            }
        }
        catch (err) {
            console.log("Error in handleFoodOrderDiscount function")
        }
    }

    const removeDiscount = async () => {
        try {
            let payload = {
                discountPercentage: 0,
                dueAmount: (totalAmount - orders?.paidAmount),
                afterDiscount: Math.round(totalAmount)
            }
            const res = await services.property.kotOrderDiscountService(payload, orders?.id)
            if (res.status === 200 && res.data.status === true) {
                toast.success(`Discount Removed`, { autoClose: 1000, pauseOnHover: true, position: "top-right" });
                setPaymentInput(false)
                refreshKot();
            }
        }
        catch (err) {
            console.log("Error in removeDiscount function")
        }
    }

    // As backup
    // let finalPayableAmount = Math.round(payableAmount);
    // let payableAmount = (Number(beforeTaxAmount) + Number(taxAmount) - Number(totalDiscount));
    // let taxAmount = (totalAmount - beforeTaxTotal).toFixed(2);
    // const totalDiscount = (beforeTaxAmount * foodDiscount / 100);

    let enteredAmount = orders ? parseFloat(watch()?.amount || 0) : parseFloat(0);

    const [paymentInput, setPaymentInput] = useState(false)
    const [foodDiscount, setFoodDiscount] = useState(0)

    useEffect(() => { setFoodDiscount(orders?.discountPercentage) }, [orders?.discountPercentage])

    let allItems = [];
    if (orders?.orderItems && orders.orderItems !== '' && orders.orderItems !== 'undefined') {
        try {
            let parsedItems = JSON.parse(orders.orderItems);
            allItems.push(...parsedItems);
        } catch (error) {
            console.error('Invalid JSON:', error);
        }
    }
    // ✅ Step 2: Calculate Totals
    let totalAmt = 0;
    let beforeTaxAmount = 0;
    let itemsTaxAmount = 0;

    allItems.forEach(item => {
        let itemTotalBeforeTax = item.qty * item.amountBeforeTax;
        let itemOriginalTotal = item.totalAmount;
        let itemTaxTotal = item.taxAmount
        totalAmt += itemOriginalTotal;
        beforeTaxAmount += itemTotalBeforeTax;
        itemsTaxAmount += itemTaxTotal
    });

    let totalAmount = totalAmt;
    let beforeTaxTotal = (beforeTaxAmount).toFixed(2);
    let discountAmount = (beforeTaxAmount * foodDiscount / 100).toFixed(2);
    let taxAmount = ((beforeTaxTotal - (discountAmount ? discountAmount : 0)) * 5 / 100).toFixed(2)
    let payAmount = (beforeTaxTotal - discountAmount + ((beforeTaxTotal - (discountAmount ? discountAmount : 0)) * 5 / 100) - orders?.paidAmount).toFixed(2)
    let afterDiscountAmount = (beforeTaxTotal - discountAmount + ((beforeTaxTotal - (discountAmount ? discountAmount : 0)) * 5 / 100)).toFixed(2)
    let withoutDiscountPaymentAmount = orders?.discountPercentage != 0 ? payAmount : (orders?.orderAmount - orders?.paidAmount)
    // withoutDiscountPaymentAmount = withoutDiscountPaymentAmount.toFixed(2)

    const paymentSubmit = async (payload) => {
        if (payload?.amount > orders?.dueAmount) {
            toast.error("Can not collect more then due amount", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
            return
        }
        if (payload.transactionId?.length <= 0 && payload.paymentMode == PAYMENT_MODES.UPI) {
            toast.error("Please Enter Transaction ID*", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
            return;
        }
        setButtonDisable(true)
        try {
            const payingNow = Number(payload.amount || 0);
            // const updatedCollected = collectedAmount + payingNow;
            const updatedCollected = payingNow;
            const realPayload = {
                order_id: orders.id,
                property_id: userDetail?.propertyId,
                payment_mode: paymentMode,
                orderAmount: Number(totalAmount),
                payment_amount: updatedCollected,
                totalDiscountAmount: discountAmount
            };
            const res = await services.property.kotPaymentservice(realPayload);
            if (res.status === 200 && res.data.status === true) {
                setButtonDisable(false)
                toast.success("Food Payment Collected", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
                setPaymentModal(false)
                refreshKot();
            }
        }
        catch (error) {
            console.error("Payment Error:", error);
            toast.error("Something went wrong!", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
        }
    };

    const { paymentMode } = watch()

    useEffect(() => { setValue("amount", Math.round(withoutDiscountPaymentAmount)); }, [orders, paymentModal, withoutDiscountPaymentAmount])

    return (
        <Modal
            size="lg"
            show={paymentModal}
            onHide={() => setPaymentModal(false)}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            className="checkInModal"
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">  Food Order Payment</Modal.Title>
                <button className="closeButton" onClick={() => { setPaymentModal(false); }} > X</button>
            </Modal.Header>
            <Modal.Body className='pl-3 pr-3'>
                <div className="row">
                    <div className="col-lg-7">
                        <div className="unpaid-orders">
                            <div className="box">
                                <h5 className="flex justify-content-between  fw-bold">
                                    <span>Order ID - {orders?.id}</span>
                                    <span>{moment(orders?.createdAt).format('HH:mm - DD-MM-YYYY')}</span>
                                    <span>{showPrice(orders.orderAmount)}</span>
                                </h5>
                                <table className="table text-center">
                                    <thead>
                                        <tr>
                                            <th className="fs-10px text-left">Item Name</th>
                                            <th className="fs-10px">QTY</th>
                                            <th className="fs-10px">Price</th>
                                            <th className="fs-10px">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            myOrder?.map((data, ind) => {
                                                return (
                                                    <tr key={ind}>
                                                        <td className="fs-10px text-left">{data.name}</td>
                                                        <td className="fs-10px">{data?.qty}</td>
                                                        <td className="fs-10px">{data.price}</td>
                                                        <td className="fs-10px">
                                                            {showPrice(parseInt(data?.qty) * parseInt(data?.price))}
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="amount-section">
                            <span className="fw-600 text-dark">Food Amount</span>
                            <span className="amount">₹{beforeTaxTotal}</span>
                        </div>
                        <div className="amount-section">
                            <span className="fw-600 text-dark">Discount</span>
                            <span className="amount">₹{discountAmount}</span>
                        </div>
                        <div className="amount-section">
                            <span className="fw-600 text-dark">Tax</span>
                            {/* {taxAmount} */}
                            ₹{orders?.discountPercentage == 0 ? (itemsTaxAmount).toFixed(2) : taxAmount}
                        </div>
                        <div className="amount-section">
                            <span className="fw-600 text-dark">Collected Amount</span>
                            <span className="amount">₹{orders?.paidAmount == null ? 0 : orders?.paidAmount}</span>
                        </div>
                        <div className="amount-section">
                            <span className="fw-600 text-dark">Payable Amount</span>
                            <span className="amount">₹{Math.round(withoutDiscountPaymentAmount)}</span>
                        </div>

                        {/* Payable Section */}

                        {/* <div className="amount-section">
                            <span className="fw-600 text-dark">{bookingDetails?.dueFoodAmount < 0 ? "Amount to Refund" : "Payable Amount"}</span>
                            <span className={`amount ${bookingDetails?.dueFoodAmount < 0 ? "text-danger" : "text-success"}`}>₹{Math.abs(orders?.dueAmount || 0)}</span>
                        </div> */}
                        <label className="label form-label fs-13 text-dark mt-4 mb-0">Add Discount</label>
                        <div className="d-flex discount-box input-group mb-3">
                            <input
                                type="number"
                                className="form-control rounded-0"
                                value={foodDiscount}
                                onChange={(e) => setFoodDiscount(e.target.value)}
                                placeholder="Enter Discount Percentage"
                                disabled={!paymentInput && (orders?.discountPercentage > 0 || orders?.discountPercentage == null)}
                                style={{ height: '30px !important' }} />
                            <span className="input-group-text">%</span>
                            <button
                                type="button"
                                className="btn btn-success btn-sm rounded-0"
                                onClick={handleFoodOrderDiscount}
                                disabled={!paymentInput && (orders?.discountPercentage > 0 || orders?.discountPercentage == null)}
                                style={{ height: '30px !important' }}>
                                Apply
                            </button>
                            {
                                // bookingDetails?.dueFoodAmount != 0 &&
                                <button
                                    className="btn btn-danger btn-sm"
                                    disabled={orders?.discountPercentage == 0}
                                    onClick={removeDiscount}>
                                    Remove
                                </button>
                            }
                        </div>
                        <Form className="popup-form onboardForm" onSubmit={handleSubmit(paymentSubmit)}>
                            <div className="form-group">
                                <label>Amount</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Collect Amount"
                                    {...register('amount', { required: 'Amount is required' })}
                                />
                                {errors.amount && (<span className="text-danger">{errors.amount.message}</span>)}
                            </div>
                            <div className="form-group mb-1">
                                <Form.Label className="label">Mode of Payment</Form.Label>
                                <select {...register("paymentMode")} className="formControl">
                                    <option selected disabled value="">select</option>
                                    <option value={PAYMENT_MODES.CASH}>Cash</option>
                                    <option value={PAYMENT_MODES.UPI}>UPI</option>
                                    <option value={PAYMENT_MODES.CARD}>Card</option>
                                    {/* <option value={PAYMENT_MODES.PREPAID}>Prepaid</option> */}
                                </select>
                                {errors?.paymentMode?.message && (
                                    <div className="error-text">
                                        <img alt="" src={AlertIcon} />
                                        <span><ErrorMessage errors={errors} name={"paymentMode"} /></span>
                                    </div>
                                )}
                            </div>

                            {watch()?.paymentMode == PAYMENT_MODES.UPI && (
                                <div className="form-group mb-1">
                                    <label
                                        htmlFor={"transactionId"}
                                        className="label form-label"
                                    ></label>
                                    <input
                                        className={`formControl border`}
                                        autoComplete="off"
                                        autoFocus={true}
                                        type="text"
                                        placeholder={"Transaction Id"}
                                        {...register("transactionId")}
                                    />
                                </div>
                            )}
                            <Modal.Footer className="pl-0 pr-0 border-top-0">
                                <Button type="submit" className="w-auto" disabled={buttonDisable || enteredAmount <= 0 || !watch()?.paymentMode}>
                                    Collect
                                </Button>
                            </Modal.Footer>
                        </Form>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default PaymentModal